import React from 'react';
interface VolumePanelProps {
  number: string;
  title: string;
}

/**
 * Typographic stand-in for volumes without cover artwork. Same page ratio as
 * a cover, so swapping in a real image later doesn't shift the layout.
 */
export function VolumePanel({
  number,
  title
}: VolumePanelProps) {
  return <div className="flex aspect-[1688/2184] w-full p-[6%]" aria-hidden data-id="element-262" data-mp="2whcnco4dguyx">
      <div className="flex w-full flex-col justify-between border border-ivory/25 p-[9%]" data-id="element-263" data-mp="3u4bkt12w26xv">
        <span className="label-tech text-olive-light" data-id="element-264" data-mp="3u1z56ukls8nz">Volume</span>
        <span className="font-brand text-[clamp(4.5rem,22vw,7.5rem)] font-normal leading-none text-ivory lg:text-[6.5rem]" data-id="element-265" data-mp="3p5rz91s7ix61">
          {number}
        </span>
        <span data-id="element-266" data-mp="3f7klssx4mx8s">
          <span className="block h-px w-10 bg-olive-light" data-id="element-267" data-mp="3f615517k6k6h" />
          <span className="mt-3 block text-balance font-brand text-[1.15rem] font-bold leading-snug text-ivory" data-id="element-268" data-mp="28qz5fqfi4ci2">
            {title}
          </span>
        </span>
      </div>
    </div>;
}